  $(document).ready(function(){
    $('.products-row').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: false,
      prevArrow: `<button type="button" class="slick-prev custom-prev">
      <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_8_679)">
<circle cx="23.5" cy="23.5" r="20" fill="white"/>
<rect width="15" height="15" transform="translate(16.5 15.5)" fill="white"/>
<path d="M26.5 29.5L19.5 23L26.5 16.5" stroke="#1A1A1A" stroke-width="1.4" stroke-linecap="square"/>
</g>
<defs>
<filter id="filter0_d_8_679" x="0" y="0" width="51" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="2" dy="2"/>
<feGaussianBlur stdDeviation="2.75"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8_679"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8_679" result="shape"/>
</filter>
</defs>
</svg>

    </button>`,
    nextArrow: `<button type="button" class="slick-next custom-next">
      <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_8_684)">
<circle cx="20" cy="20" r="20" transform="matrix(-1 0 0 1 43.5 3.5)" fill="white"/>
<rect width="15" height="15" transform="matrix(-1 0 0 1 30.5 15.5)" fill="white"/>
<path d="M20.5 29.5L27.5 23L20.5 16.5" stroke="#1A1A1A" stroke-width="1.4" stroke-linecap="square"/>
</g>
<defs>
<filter id="filter0_d_8_684" x="0" y="0" width="51" height="51" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dx="2" dy="2"/>
<feGaussianBlur stdDeviation="2.75"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8_684"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8_684" result="shape"/>
</filter>
</defs>
</svg>

    </button>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  });